import React from 'react';
import {Icon} from 'antd';

import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const refusalItems = [
    {
        id: 'reason',
        number: 1,
        content: 'Изучите указанную в уведомлении причину отказа.',
        area: {
            top: 39,
            left: 15,
            width: 72,
            height: 28
        }
    }
];


const correctionItems = [
    {
        id: 'cabinet',
        number: 1,
        content: (
            <>
                Перейдите в раздел <strong>«Кабинет»</strong>.
            </>
        ),
        area: {
            top: 3,
            left: 34.4,
            width: 5.8,
            height: 8
        }
    },
    {
        id: 'legal-entities',
        number: 2,
        content: (
            <>
                Откройте вкладку
                <strong> «Юридические лица»</strong>.
            </>
        ),
        area: {
            top: 54.56,
            left: 3.18,
            width: 21.68,
            height: 9.21
        }
    },
    {
        id: 'text',
        number: 3,
        content: 'Исправьте текстовую информацию.',
        area: {
            top: 88.2,
            left: 84.68,
            width: 1.59,
            height: 8.85
        }
    },
    {
        id: 'documents',
        number: 4,
        content: 'Замените или добавьте необходимые документы.',
        area: {
            top: 88.2,
            left: 86.82,
            width: 1.59,
            height: 8.85
        }
    },
    {
        id: 'submit',
        number: 5,
        content: (
            <>
                Нажмите кнопку
                <strong> «Отправить на согласование»</strong>.
            </>
        ),
        area: {
            top: 87.49,
            left: 70.49,
            width: 12.26,
            height: 10.27
        }
    }
];


const detailsItems = [
    {
        id: 'details',
        number: 1,
        content: (
            <>
                Нажмите кнопку <strong>«Подробности»</strong>.
            </>
        ),
        area: {
            top: 81.53,
            left: 74.01,
            width: 9.65,
            height: 12.76
        }
    }
];


const resendItems = [
    {
        id: 'applications',
        number: 2,
        content: (
            <>
                Откройте раздел
                <strong> «Заявки к грузоотправителям»</strong>.
            </>
        ),
        area: {
            top: 42.74,
            left: 0,
            width: 22.93,
            height: 13.09
        }
    },
    {
        id: 'resend',
        number: 3,
        content: (
            <>
                Нажмите кнопку
                <strong> «Отправить повторно»</strong>.
            </>
        ),
        area: {
            top: 35.47,
            left: 67.09,
            width: 26.22,
            height: 9.82
        }
    }
];


export default function LegalEntityDisagreementInstruction() {
    return (
        <InstructionLayout title="Действия в случае несогласования">
            <p className="instruction-intro">
                Если юридическое лицо не прошло согласование,
                изучите причину отказа, исправьте данные
                и повторно отправьте информацию на согласование.
            </p>

            <div className="service-highlight">
                <span className="service-highlight__icon">
                    <Icon type="warning"/>
                </span>

                <div>
                    <strong className="service-highlight__title">
                        Причина отказа
                    </strong>

                    <p className="service-highlight__text">
                        Уведомление об отказе приходит автоматически
                        и отправляется на электронную почту,
                        указанную клиентом.
                    </p>
                </div>
            </div>

            <InstructionStep
                number="1"
                title="Изучите причину несогласования"
            >
                <div className="instruction-copy">
                    <p>
                        В уведомлении будет указано, какие данные
                        или документы не прошли согласование.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/legal-entity-disagreement/01-notification.png"
                    alt="Уведомление о несогласовании юридического лица"
                    items={refusalItems}
                />
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Исправьте данные и отправьте их повторно"
            >
                <div className="instruction-copy">
                    <p>
                        Найдите юридическое лицо, которое не прошло
                        согласование, исправьте данные и повторно
                        отправьте их на проверку.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/legal-entity-disagreement/02-correction-and-resubmission.png"
                    alt="Исправление данных юридического лица и повторная отправка на согласование"
                    items={correctionItems}
                />
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Повторно подайте заявку грузоотправителю"
            >
                <div className="instruction-copy">
                    <p>
                        Найдите грузоотправителя, который отклонил
                        согласование, и откройте подробную информацию
                        о заявке.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/legal-entity-disagreement/03-details.png"
                    alt="Кнопка «Подробности»"
                    items={detailsItems}
                />

                <InstructionSpotlight
                    src="/img/instructions/legal-entity-disagreement/04-resend.png"
                    alt="Повторная отправка заявки грузоотправителю"
                    items={resendItems}
                />

                <div className="instruction-copy">
                    <p>
                        После повторной отправки процесс согласования
                        начнётся заново.
                    </p>
                </div>
            </InstructionStep>
        </InstructionLayout>
    );
}